import React, { useState, useEffect } from "react";
import {
    fetchOPDBanner, fetchFilterOPD, fetchAllSpecialities, downloadOPDSchedulePDF, storeRequestCallback,
    fetchOpdSchedulePageSeo
} from "../Adapter/PageAdapter";
import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { Toaster, toast } from 'sonner';
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import "react-toastify/dist/ReactToastify.css";
import opdBanner from "../assets/images/careerdetailban.jpg";
import downArrow from "../assets/images/doc-detail/downarrow.svg";
import newArrImg from "../assets/images/arrw.svg";

const OPDSchedule = () => {
    // State for specialties & selected specialty
    const [bannerData, setBannerData] = useState([]);
    const [specialties, setSpecialties] = useState([]);
    const [selectedSpecialty, setSelectedSpecialty] = useState("");
    const [opdSchedules, setOpdSchedules] = useState([]);
    const [doctorsList, setDoctorsList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isManuallyOpened, setIsManuallyOpened] = useState(false);
    const [formData, setFormData] = useState({
        patientName: "",
        // countryCode: "",
        contact_number: "",
        email: "",
        message: "",
        appointment_date: "",
        doctor_id: "",
        doctor_name: "",
        speciality_id: "",
        speciality_name: "",
    });

    // const seoData = useSeo(fetchOpdSchedulePageSeo);
    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchOpdSchedulePageSeo...");
                const res = await fetchOpdSchedulePageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("fetch Opd Schedule Page Seo fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchOPDBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }
        };

        fetchData();
    }, []);

    // Fetch all specialties from API on component mount
    useEffect(() => {
        const fetchSpecialties = async () => {
            try {
                const response = await fetchAllSpecialities();
                if (response && response.specialities) {
                    setSpecialties(response.specialities);
                } else {
                    // toast.error("Failed to load specialties", { position: "top-right" });
                }
            } catch (error) {
                toast.error("Error fetching specialties", { position: "top-right" });
            }
        };

        fetchSpecialties();
    }, []);

    // Fetch OPD schedule dynamically based on specialty selection
    const fetchOPDSchedule = async (specialityId) => {
        try {
            const response = await fetchFilterOPD(specialityId);
            if (response && response.data) {
                setOpdSchedules(response.data);
                // toast.success("OPD Schedule Loaded Successfully!", { position: "top-right" });
            } else {
                setOpdSchedules([]);
                // toast.info("No OPD schedule available for this specialty.", { position: "top-right" });
            }
        } catch (error) {
            setOpdSchedules([]);
            // toast.warn("OPD schedule not available for this!.", { position: "top-right" });
        }
    };

    // Fetch doctors when a specialty is selected
    const handleSpecialtyList = async (e) => {
        const specialityId = e.target.value;
        setFormData({
            ...formData,
            speciality: specialityId,
            doctor: "",
        });

        try {
            const response = await fetchFilterOPD(specialityId);
            if (response && response.data) {
                setDoctorsList(response.data);
            } else {
                setDoctorsList([]);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    };

    useEffect(() => {
        if (!isManuallyOpened) {  // Only trigger the timer if not manually opened
            const timer = setTimeout(() => {
                setShowModal(true);
            }, 1500000);

            return () => clearTimeout(timer); // Cleanup timer on component unmount
        }
    }, [isManuallyOpened]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Only allow numbers and plus in contactNo
        if (name === "contactNo" || name === "countryCode") {
            const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
            setFormData({ ...formData, [name]: sanitizedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = () => {
        setShowModal(true);
        setIsManuallyOpened(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);

        // Manually remove Bootstrap modal-related classes
        document.body.classList.remove("modal-open");

        // Remove the modal backdrop if it exists
        const modalBackdrops = document.getElementsByClassName("modal-backdrop");
        while (modalBackdrops.length > 0) {
            modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
        }
    };

    // Handle Specialty Selection Change

    const handleSubmit = async (event) => {
        event.preventDefault();

        const payload = {
            patient_name: formData.patientName,
            // country_code: formData.countryCode,
            contact_number: formData.contactNo,
            email: formData.email,
            message: formData.message,
            appointment_date: formData.date,
            doctor_id: formData.doctor,
            speciality_id: formData.speciality,
            doctor_name: doctorsList.find(doc => doc.id == formData.doctor)?.doctor_name || "",
            speciality_name: specialties.find(spec => spec.id == formData.speciality)?.name || "",
        };

        const crmPayload = {
            first_name: payload.patient_name?.split(" ")[0],
            last_name: payload.patient_name?.split(" ")[1] || "",
            phone: payload.contact_number,
            email: payload.email,
            message: payload.message,
            source: "Doctor List Page Form",
            fortis_doctor_name: payload.doctor_name,
            referred_for_specilaity: payload.speciality_name,
            expected_admission_date: payload.appointment_date,
        };

        try {
            const result = await storeRequestCallback(payload);

            if (result.backendResult?.message && result.crmResult?.status === "success") {
                toast.success("Form submitted successfully!");
                // Reset form here
                handleCloseModal();
            } else {
                toast.error("Request submitted successfully!");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }

    };

    const handleSpecialtyChange = (e) => {
        const specialityId = e.target.value;
        setSelectedSpecialty(specialityId);
        if (specialityId) {
            fetchOPDSchedule(specialityId);
        } else {
            setOpdSchedules([]);
        }
    };

    const handleDownloadPDF = async () => {
        try {
            await downloadOPDSchedulePDF();
            toast.success("PDF downloaded successfully!", { position: "top-right" });
        } catch (error) {
            toast.error("Failed to download the PDF.", { position: "top-right" });
        }
    };


    return (
        <>
            {/* <SeoHelmet seoData={seoData} /> */}
            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                    {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )}
                </Helmet>
            )}
            <Toaster position="top-right" />

            {/* Banner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData.img_path.replace('.', '')}`}
                                alt={bannerData.banner_heading || "OPD Schedule"}
                            />
                        ) : (
                            <img src={opdBanner} alt="OPD Schedule" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'OPD Schedule'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Overview Section */}
            <section className="section about-host">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="finnest host-det mobtopmarg text-center">
                                <h4>Have A Look On Our <span>Doctor's Time Schedule</span></h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* OPD Schedule Section */}
            <section className="academics-docnurse-sec margnbot90">
                <div className="cust-container">
                    <div className="academics-docnurse-inner">
                        <div className="academics-docnurse-tabs td-wd-mob">

                            {/* Specialty Selection */}
                            <div className="select-yearandmonthtab">
                                <div className="yearbox">
                                    <select
                                        value={selectedSpecialty}
                                        onChange={handleSpecialtyChange}
                                    >
                                        <option value="">Select Specialty</option>
                                        {specialties.map((specialty) => (
                                            <option key={specialty.id} value={specialty.id}>
                                                {specialty.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Download Button */}
                                <div className="yearbox">
                                    <div className="jdapplybtn">
                                        <a href="#" className="btn with-color with-arr" onClick={handleDownloadPDF}>
                                            <img src={downArrow} alt="Download" />
                                            Download OPD Schedule
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* OPD Schedule Table */}
                            <div className="opd-sc-table tab-content">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Doctor Name</th>
                                            <th>Specialty</th>
                                            <th>Days</th>
                                            <th>OPD Timing</th>
                                            <th>Appointment</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {opdSchedules.length > 0 ? (
                                            opdSchedules.map((schedule, index) => (
                                                <tr key={index}>
                                                    <td>{schedule.name_prefix} {schedule.doctor_name}</td>
                                                    <td>{schedule.speciality_name}</td>
                                                    {/* <td>{schedule.days}</td> */}
                                                    <td dangerouslySetInnerHTML={{ __html: schedule.days }} />
                                                    <td dangerouslySetInnerHTML={{ __html: schedule.timing }} />
                                                    {/* <td>
                                                        {(schedule.start_time === "00:00 AM" && schedule.end_time === "00:00 PM") ?
                                                            "By Appointment" :
                                                            `${schedule.start_time} - ${schedule.end_time}`
                                                        }
                                                    </td> */}
                                                    <td>
                                                        {schedule.appointment_status === "active" ? (
                                                            <a href="#" onClick={handleOpenModal}>Request a Call Back</a>
                                                        ) : (
                                                            <span>Not Available</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                                                    No OPD schedule available. For a specialty.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* Modal for patient form */}
            {showModal && (
                <div
                    className="modal fade custmodal-width custom-modalwdth2 show"
                    style={{ display: "block" }}
                    id="patienform"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modalclosebtn">
                                <button
                                    type="button"
                                    className="close"
                                    onClick={handleCloseModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="intern-form-inner">
                                    <h5>Request A Call Back Form:</h5>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="patientName">
                                                        Full Name of the Patient <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="patientName"
                                                        name="patientName"
                                                        value={formData.patientName}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            {/* <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="countryCode">
                                                        Country Code <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="countryCode"
                                                        name="countryCode"
                                                        value={formData.countryCode}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div> */}
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="contactNo">
                                                        Contact No <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="contactNo"
                                                        name="contactNo"
                                                        value={formData.contactNo}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="email">Email</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="speciality">Speciality <span>*</span></label>
                                                    <select
                                                        id="speciality"
                                                        name="speciality"
                                                        value={formData.speciality}
                                                        onChange={handleSpecialtyList}
                                                    >
                                                        <option value="">Please select Speciality</option>
                                                        {specialties.map((specialty) => (
                                                            <option key={specialty.id} value={specialty.id}>
                                                                {specialty.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="doctor">Select Doctor <span>*</span></label>
                                                    <select
                                                        id="doctor"
                                                        name="doctor"
                                                        value={formData.doctor}
                                                        onChange={(e) => setFormData({ ...formData, doctor: e.target.value })}
                                                    >
                                                        <option value="">Please select Doctor</option>
                                                        {doctorsList.map((doctor) => (
                                                            <option key={doctor.id} value={doctor.id}>
                                                                {doctor.doctor_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="date">Please Select Date <span>*</span></label>
                                                    <input
                                                        type="date"
                                                        id="date"
                                                        name="date"
                                                        value={formData.date}
                                                        onChange={handleInputChange}
                                                        inputProps={{
                                                            min: new Date().toISOString().slice(0, 16),
                                                            max: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().slice(0, 16)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <div className="int-form-item">
                                                    <label htmlFor="message">Message</label>
                                                    <textarea
                                                        id="message"
                                                        name="message"
                                                        value={formData.message}
                                                        onChange={handleInputChange}
                                                        rows="5"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <div className="int-form-item">
                                                    <button type="submit">
                                                        <img src={newArrImg} alt="" />
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default OPDSchedule;
